import { useEffect, useState } from 'react';
import styles from '../styles/Placeholder.module.css';

const Placeholder = () => {
  let imageFolder = 'mobile';
  if (process.browser) {
    imageFolder = window.screen.width < 1280 ? 'mobile' : 'desktop';
  }
  const [frame, setFrame] = useState(1);
  useEffect(() => {
    const interval = setInterval(() => {
      if (frame === 15) {
        setFrame(1);
      } else {
        setFrame(frame + 1);
      }
    }, 250);
    return () => clearInterval(interval);
  }, [frame]);

  return (
    <div className={styles.placeholder}>
      <div className={styles.logo}>
        <a
          href="https://vk.com/itmomegabattle
        "
        >
          <img src="/logo.png" width="190" height="150" />
        </a>
      </div>
      <div className={styles.slider}>
        <img src={`/photos/${imageFolder}/${frame}.webp`} />
      </div>
    </div>
  );
};

export default Placeholder;
